import { render, staticRenderFns } from "./LedgerCostManager.vue?vue&type=template&id=36e791e4&scoped=true"
import script from "./LedgerCostManager.vue?vue&type=script&lang=js"
export * from "./LedgerCostManager.vue?vue&type=script&lang=js"
import style0 from "./LedgerCostManager.vue?vue&type=style&index=0&id=36e791e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e791e4",
  null
  
)

export default component.exports